<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="critereRecherche">
    <div class="column is-12 pdb-0"
       :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('journalPaiements.filtre.titre') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('journalPaiements.filtre.sousTitre') }}
        </span>
      </div>
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
      :class="[
        {'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.dates"
            :label="$t('journalPaiements.filtre.dates')">
          </input-periode>
        </div>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalPaiements.filtre.domiciliationBancaire')">
          <qd-taginput
            v-if="domBancaireTags"
            v-model="domBancaireSelected"
            :data="domBancaireTags"
            type="is-primary"
            icon="magnify"
            autocomplete
            open-on-focus
            field="libelle"
            @typing="getFilteredDomBancaireTags"
            @input="getDomBancaireTag">
            <template slot-scope="props">
              {{ afficherBanque(props.option) }}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalPaiements.filtre.referencePaiement')">
          <b-input v-model="critereRecherche.referencePaiement ">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalPaiements.filtre.nomTire')">
          <b-input v-model="critereRecherche.emetteur ">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalPaiements.filtre.borneMontantRegle')">
          <div class="columns is-vcentered">
            <input-currency v-model="critereRecherche.borneDebit.borneMin"
                            class="column"
                            :peutEtreNegatif="true"
                            isNumber="true">
            </input-currency>
            <span class="column is-1">{{$t('compteTiers.filtres.montantsA')}}</span>
            <input-currency v-model="critereRecherche.borneDebit.borneMax"
                            class="column"
                            :peutEtreNegatif="true"
                            isNumber="true">
            </input-currency>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('remiseBancaire.filtre.modePaiement')">
          <qd-taginput v-if="modeReglementTags"
                        v-model="modeReglementSelected"
                        :data="modeReglementTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredModeReglementTags"
                        @input="getModeReglementTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t(getFournisseurLabel)">
          <qd-taginput
            v-model="critereRecherche.tiersIds"
            :data="filteredTagsTiers"
            :loading="isFetchingTiers"
            @typing="getfilteredTiers"
            autocomplete
            icon="magnify"
            type="is-primary"
            field="nomCommercial">
            <template slot-scope="props">
              {{ props.option.nomWithAdresse }}
            </template>
            <template slot="empty">
              <div v-if="!isFetchingTiers">
                {{$t('general.autocomplete.noRslt')}}
              </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t(getCodeLabel)">
          <b-input v-model="critereRecherche.codeFactureOuContrat ">
          </b-input>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('remiseBancaire.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('remiseBancaire.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import inputPeriode from '@/components/general/inputPeriode';
import genererCritereRechercheJournalPaiements from '@/services/journalPaiements/genererCritereRechercheJournalPaiements';
import { SET_CRITERE_JOURNAL_PAIEMENTS } from '@/store/modules/journalPaiements-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  TIERS_SOUS_TYPE_COLLECTIVITE,
  LISTE_SOUS_TYPE_FOURNISSEURS_PAGES,
} from '@/configuration/tiers/tiersConf';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { MODULE_TLPE, MODULE_BAIL, MODULE_ACHAT } from '@/configuration/devisConf';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  components: {
    errorMsgComponent,
    inputPeriode,
    inputCurrency,
  },
  props: {
    nameStore: {
      type: String,
      required: false,
      default: 'journalPaiements',
    },
    moduleDcf: {
      type: String,
      required: false,
      default: MODULE_BAIL,
    },
  },
  data() {
    return {
      constantes: {},
      errors: [],
      critereRecherche: null,
      domBancaireSelected: [],
      modeReglementTags: null,
      listeModeReglementBase: [],
      modeReglementSelected: [],
      filteredTagsTiers: [],
      isFetchingTiers: false,
      domBancaireTags: null,
      clientsSelected: [],
    };
  },
  computed: {
    critereRechercheJournalPaiements: {
      get() {
        return this.$store.getters[`${this.nameStore}/critereRechercheJournalPaiements`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/SET_CRITERE_JOURNAL_PAIEMENTS`, value);
      },
    },
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    domBancaire() {
      return this.parametre(PARAMETRES_KEYS.domiciliationBancaire);
    },
    modesReglement() {
      return this.parametre(PARAMETRES_KEYS.modeReglement);
    },
    getFournisseurLabel() {
      if (this.moduleDcf === MODULE_TLPE) return 'journalPaiements.filtre.collectivite';
      if (this.moduleDcf === MODULE_ACHAT) return 'journalPaiements.filtre.fournisseurs';
      return 'journalPaiements.filtre.bailleurs';
    },
    getCodeLabel() {
      if (this.moduleDcf === MODULE_TLPE) return 'journalPaiements.filtre.codeTitreRecette';
      if (this.moduleDcf === MODULE_ACHAT) return 'journalPaiements.filtre.codeFactureAchat';
      return 'journalPaiements.filtre.codeFactureOuContrat';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    setCritereRechercheJournalPaiements(critere) {
      return this.$store.commit(`${this.nameStore}/${SET_CRITERE_JOURNAL_PAIEMENTS}`, critere);
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getfilteredTiers: debounce(async function getTiers(search) {
      this.filteredTagsTiers = [];
      if (!search) return;
      this.isFetchingTiers = true;
      try {
        let sousTypes = [
          TIERS_SOUS_TYPE_BAILLEUR_PRO,
          TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
          TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
          TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
        ];
        if (this.moduleDcf === MODULE_TLPE) {
          sousTypes = [TIERS_SOUS_TYPE_COLLECTIVITE];
        }
        if (this.moduleDcf === MODULE_ACHAT) {
          sousTypes = LISTE_SOUS_TYPE_FOURNISSEURS_PAGES.map(el => el.code);
        }
        const tiers = (await getAllTiers({
          query: {
            nomsCommercialOuNomsJuridique: [search],
            societeId: this.societeActiveId,
            type: TIERS_TYPE_FOURNISSEUR,
            sousType: sousTypes,
          },
        })).data.result.items;
        tiers.forEach((el) => {
          el.nomWithAdresse = el.nomCommercial;
          if (adressFullStringGetter(el.adressePostale, false) !== '') {
            el.nomWithAdresse += ' - ' + adressFullStringGetter(el.adressePostale, false);
          }
        });
        this.filteredTagsTiers = tiers
          .filter((el) => !this.critereRecherche.tiersIds?.map(el => el.id).includes(el.id));
        this.isFetchingTiers = false;
      } catch (e) {
        this.isFetchingTiers = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheJournalPaiements);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([
          PARAMETRES_KEYS.domiciliationBancaire,
          PARAMETRES_KEYS.modeReglement,
        ]);
        this.listeDomBancaireBase = this.domBancaire;
        if (this.critereRecherche.domiciliationBancaireIds.length > 0) {
          this.domBancaireSelected = this.listeDomBancaireBase.filter((domBancaire) => {
            return this.critereRecherche.domiciliationBancaireIds.includes(domBancaire.id);
          });
        }
        this.listeModeReglementBase = this.modesReglement;
        if (this.critereRecherche.modeDeReglementIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.critereRecherche.modeDeReglementIds.includes(modeReglemnt.id);
          });
        }
        this.clientsSelected = this.critereRecherche.payeurs;
        this.getDomBancaireTag();
        this.getModeReglementTag();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
    afficherBanque(domBancaire) {
      const libelle = `${domBancaire.libelle} -`;
      const libelleBanque = domBancaire.libelleBanque && domBancaire.libelleBanque !== 'null'
        ? domBancaire.libelleBanque : '';
      return `${libelle} ${libelleBanque}`;
    },
    appliquerCritere() {
      this.errors = [];
      if (this.critereRecherche.dates.dateFin
        && this.critereRecherche.dates.dateDebut
        > this.critereRecherche.dates.dateFin) {
        this.errors.push({
          message: 'validation.dateDebutGreaterDateFin',
        });
      }
      if (this.errors.length > 0) return;
      this.critereRecherche.domiciliationBancaireIds = this.domBancaireSelected
        .map((domBancaire) => {
          return domBancaire.id;
        });
      this.critereRecherche.modeDeReglementIds = this.modeReglementSelected.map((modeReglement) => {
        return modeReglement.id;
      });
      this.setCritereRechercheJournalPaiements(this.critereRecherche);
      this.$emit('recherche');
    },
    viderCritere() {
      this.domBancaireSelected = [];
      this.modeReglementSelected = [];
      this.clientsSelected = [];
      this.getDomBancaireTag();
      this.getModeReglementTag();
      this.critereRecherche = genererCritereRechercheJournalPaiements(this.moduleDcf);
    },
    getDomBancaireTag() {
      this.domBancaireTags = this.listeDomBancaireBase.filter((domBancaire) => {
        return !this.domBancaireSelected.map(a => a.id).includes(domBancaire.id);
      });
    },
    getFilteredDomBancaireTags(text) {
      this.getDomBancaireTag();
      this.domBancaireTags = this.domBancaireTags.filter((domBancaire) => {
        return domBancaire.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
